<template>
  <div>
    <template v-if="!loading">
      <h1>{{ $lang("澳門婦女體育嘉年華") }}</h1>
      <div class="dashed">
        <div
          class="summer-attention"
          v-if="womenCarnival && womenCarnival.content"
        >
          <div v-html="womenCarnival.content"></div>
        </div>
        <div v-if="isEnroll">
          <template v-if="isEnroll">
            <p>
              <span>{{ $lang("TEXT_VIEW_INFORMATION") }}</span>
              <span
                >（{{
                  records[0].status == "draft"
                    ? $lang("已儲存草稿")
                    : $lang("已成功提交")
                }}）</span
              >
            </p>
            <ul>
              <template v-for="item in records">
                <li v-if="item.status != 'draft'" :key="item.id">
                  <span></span>
                  <router-link
                    class="submitForm"
                    :to="`women-carnival-game/perview/${item.id}`"
                    >{{ item.title }}</router-link
                  >
                </li>
                <li v-else :key="item.id">
                  <span>{{ item.title }}</span>
                  <router-link
                    class="btn btn-primary"
                    :to="`women-carnival-game/edit/${item.id}`"
                    >{{ $lang("修改") }}</router-link
                  >
                  <b-btn variant="info" @click="handlerDelete(item.id)">{{
                    $lang("刪除")
                  }}</b-btn>
                  <!-- <b-btn variant="danger" @click="handlerSumbit(item.id)">{{$lang("提交")}}</b-btn> -->
                  <router-link
                    variant="info"
                    class="btn btn-danger"
                    :to="`women-carnival-game/edit/${item.id}`"
                    >{{ $lang("提交") }}</router-link
                  >
                </li>
              </template>
            </ul>
          </template>
        </div>
        <template v-if="!isFull">
          <div v-if="!isEnroll">
            <!-- <p>
                      <router-link to="physical-challenge-game" class="listen-tnc">{{$lang("TEXT_AGREE_CONTENT")}}</router-link>
                  </p> -->
            <div class="text-center" v-if="!isEnroll">
              <span
                @click="openModel()"
                style="
                  cursor: pointer;
                  background-color: #28a745;
                  color: white;
                  border-radius: 50px;
                  padding: 10px 20px;
                "
                >{{ $lang("TEXT_AGREE_CONTENT") }}</span
              >
            </div>
          </div>
        </template>
        <template v-else>
          <p>
            <span>
              <h4>{{ $lang("TITLE_IS_FULL") }}</h4>
            </span>
          </p>
        </template>
      </div>
    </template>
    <template v-else>
      <div class="spinner">
        <b-spinner variant="primary" label="Spinning"></b-spinner>
      </div>
    </template>
  </div>
</template>

<script>
import { $apis } from "@/helper";
import game from "@/components/game";
import List from "@/components/List";
import moment from 'moment'
export default {
  components: {
    game,
    List,
  },
  data() {
    return {
      loading: true,
      isReadOnly: true,
      isAgree: false,
      records: [],
      groups: [],
      dynamicGame: {},
    };
  },
  created() {
    this.isLoading();
    this.$store.dispatch("base/getPage");
  },
  methods: {
    async isLoading() {
      this.loading = true;
      await this.getRecordList();
      this.loading = false;
    },
    // 获取报名表记录
    async getRecordList() {
      try {
        let resp = await $apis.womenCarnival.recordList();
        resp.code === 0 && (this.records = resp.data.records);
      } catch (e) {
        console.log(e);
      }
    },
    // 删除报名表记录
    async deleteRecordDetail(id) {
      try {
        let resp = await $apis.womenCarnival.deleteRecordDetail({
          id,
        });
        await this.getRecordList();
        // await this.getGroupList();
        if (resp.code == 0) this.notification.success(this.$lang("删除成功"));
        else throw new Error(resp);
      } catch (e) {
        this.notification.error(this.$lang("删除失败"));
        console.log(e);
      }
    },
    // 正式提交表明表记录
    async formalSubmission(id) {
      try {
        let resp = await $apis.dynamic.formalSubmission({
          id,
        });
        await this.getRecordList();
        await this.getGroupList();
        if (resp.code == 0) this.notification.success(this.$lang("提交成功"));
        else throw new Error(resp);
      } catch (e) {
        this.notification.success(this.$lang("提交失败"));
        console.log(e);
      }
    },
    handlerDelete(id) {
      let r = confirm(this.$lang("是否刪除報名表!"));
      if (r == true) {
        this.deleteRecordDetail(id);
      }
    },
    handlerSumbit(id) {
      let r = confirm(this.$lang("是否確認提交!"));
      if (r == true) {
        this.formalSubmission(id);
      }
    },
    // 個人/團隊 同意報名
    openModel() {
      this.$router.push({
        path: "women-carnival-game",
      });
    },
  },
  computed: {
    womenCarnival() {
      return this.$store.state.base.womenCarnival;
    },
    isEnroll() {
      return this.records.length || 0;
    },
    isFull() {
      return this.records.isFull;
    },
     curYear(){
      return moment().format('YYYY')
    }
    // isChange() {
    //     return this.records.length < 2;
    // }
  },
};
</script>
